export default function SoilLogCallout({y, x, onClick=_.noop, children}) {
  const positionStyle = x ? {top: y, left: x} : {top: y - 28};
  return (
    <div className={x ? "soil-count-callout": "soil-level-callout"} style={positionStyle} onClick={onClick}>
      <div className="pointer"/>
      {children}
    </div>
  );
}
